import AppConstants from 'constants/AppConstants';

export function downloadToS(businessId: number): ApiAction {
  return {
    TockApi: {
      getFile: `/business/download/tos/${businessId}`,
      type: AppConstants.DOWNLOAD_TOS,
    },
  };
}
